import styles from './StepModernization.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'
import ToDownload2 from 'components/services/common/ToDownload2'
import toDownload2Styles from 'components/services/common/ToDownload2/ToDownload2.module.scss'

export interface StepModernizationDetail {
  no: string
  icon: string
  title: string
  text: string
}

export interface StepModernizationItem {
  sectionTitle: string
  sectionRead: string
  stepIcon: StepModernizationDetail[]
}

interface Props {
  StepIconEach: StepModernizationItem[]
}

const StepModernization: React.FC<Props> = ({ StepIconEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  const item =
    StepIconEach && StepIconEach.length > 0 ? StepIconEach[0] : { sectionTitle: '', sectionRead: '', stepIcon: [] }

  return (
    <section
      className={`${styles.step} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>{item.sectionTitle}</h2>
      <p className={styles.sectionRead}>{item.sectionRead}</p>
      <ul className={styles.stepList}>
        {item.stepIcon &&
          item.stepIcon.map((stepIcon, index) => (
            <li key={index} className={styles.stepList__item}>
              <div className={styles.stepList__item__no}>{stepIcon.no}</div>
              <figure className={styles.stepList__item__icon}>
                <img src={stepIcon.icon} alt={stepIcon.title} width={120} height={100} />
              </figure>
              <div className={styles.stepList__item__area}>
                <h3 className={styles.stepList__item__area__title}>{stepIcon.title}</h3>
                <p className={styles.stepList__item__area__text}>{stepIcon.text}</p>
              </div>
            </li>
          ))}
      </ul>
      <ToDownload2
        imgSrc="/images/img/download/modernization/thumbnail_modernization.webp"
        alt="失敗しないAI時代のモダナイゼーション戦略"
        title="失敗しないAI時代のモダナイゼーション戦略"
        description="DXやAI活用が進まない本質的な理由とは？計画から予算策定等、モダナイゼーションの最新動向をまとめたガイドラインです。是非ご覧ください。"
        link="/download/modernization/"
        subText="サービス資料"
        className={toDownload2Styles.layoutModernization}
      />
    </section>
  )
}

export default StepModernization
